<template>
  <form class="clearfix row">
    <div class="col-md-12">
      <div class="form-group" v-for="notif in model">
        <h6>{{$t('deliveryTypes.' + notif.delivery_type)}}</h6>
        <hr class="sm"/>
        <template v-for="message in notif.messages">
          <div class="form-group">
           <label class="">{{$t('ordersStatus.' + message.status)}}</label>
        <!--    <div><small class="pull-right">{{message.message ? message.message.length : '0'}} / 200 {{$t('marketingCampaigns.characters')}}</small>
           </div> -->
           <div v-if="message.status === 'PROCESSING' || (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION')">
            <template v-if="notif.delivery_type === 'EAT_LOCATION'">
              <input type="text" 
                    class="form-control auto-width" 
                    v-model="notifBits[notif.delivery_type][message.status][0]" 
                    v-validate="modelValidations.text"
                    :style="'width: ' + ((notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'" 
                    />
              <span> {{$t('settingsPushNotif.persons')}} </span>
              <input type="text" 
                    class="form-control auto-width" 
                    v-model="notifBits[notif.delivery_type][message.status][1]" 
                    v-validate="modelValidations.text"
                    :style="'width: ' + ((notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'" 
                    />
              <span> {{$t('settingsPushNotif.dateTime')}} </span>
              <input type="text" 
                    class="form-control auto-width" 
                    v-model="notifBits[notif.delivery_type][message.status][2]" 
                    v-validate="modelValidations.text"
                    :style="'width: ' + ((notifBits[notif.delivery_type][message.status][2].length + 1)*8 + 20) + 'px'" 
                    />
              <div class="pad-to-5">
                {{$t('settingsPushNotif.preview')}}: 
                <span class="text-italic">
                {{ notifBits[notif.delivery_type][message.status][0] }} 
                {{$t('settingsPushNotif.personsPrev')}} 
                {{notifBits[notif.delivery_type][message.status][1]}}
                {{$t('settingsPushNotif.dateTimePrev')}} 
                {{notifBits[notif.delivery_type][message.status][2]}}
              </span>
               </div> 
            </template>
            <template v-else>
              <input type="text" 
                    class="form-control auto-width" 
                    v-model="notifBits[notif.delivery_type][message.status][0]" 
                    v-validate="modelValidations.text"
                    :style="'width: ' + ((notifBits[notif.delivery_type][message.status][0].length + 1)*8 + 20) + 'px'" 
                    />
              <span> {{$t('settingsPushNotif.time')}} </span>
              <input type="text" 
                    class="form-control auto-width" 
                    v-model="notifBits[notif.delivery_type][message.status][1]" 
                    v-validate="modelValidations.text"
                    :style="'width: ' + ((notifBits[notif.delivery_type][message.status][1].length + 1)*8 + 20) + 'px'" 
                    />
              <div class="pad-to-5">
                {{$t('settingsPushNotif.preview')}}: 
                <span class="text-italic">{{ notifBits[notif.delivery_type][message.status][0] }} {{$t('settingsPushNotif.timePrev')}} {{notifBits[notif.delivery_type][message.status][1]}}</span>
               </div> 
            </template>    
           </div>
           <div v-else>
             <input type="text" class="form-control" v-model="message.message" v-validate="modelValidations.text"/>
           </div>
           
         </div>
        </template>
        <div class="pad-bt-10"></div>
      </div>
      <div class="form-group">
        <button class="btn btn-success btn-fill" @click.prevent="validate">{{$t('general.update')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
  import Vue from 'vue'
  import {Input, Button, Select} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select
    },
    props: {
      defaultData: {},
      modeldata: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        this.model = value
        this.setUpBits(value)
      }
    },
    data () {
      return {
        labels: {
          'order_new': this.$t('settingsPushNotif.order_new'),
          'order_completed_pickup': this.$t('settingsPushNotif.order_completed_pickup'),
          'order_completed_meet': this.$t('settingsPushNotif.order_completed_meet'),
          'order_completed_delivery': this.$t('settingsPushNotif.order_completed_delivery'),
          'order_completed_eat': this.$t('settingsPushNotif.order_completed_eat'),
          'order_canceled': this.$t('settingsPushNotif.order_canceled')
        },
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData, // this.countries
        modelValidations: {
          text: { required: true }
        },
        parameters: [
          '{time}',
          '{date_time}',
          '{persons_number}'
        ],
        notifBits: {
          'DELIVERY': {
            'PROCESSING': ['', '']
          },
          'PICK_UP': {
            'PROCESSING': ['', '']
          },
          'MEET_HALF': {
            'PROCESSING': ['', '']
          },
          'EAT_LOCATION': {
            'DELIVERED': ['', '', '']
          }
        }
      }
    },
    mounted () {
      this.$nextTick(function () {
        // next tick
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
            console.warn(this.errors)
          }
        }
      },
      setUpBits (model) {
        for (var idx in model) {
          let notif = model[idx]
          for (var notifIdx in notif.messages) {
            let message = notif.messages[notifIdx]
            if (message.status === 'PROCESSING' || (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION')) {
              let bits = this.getBits(message.message, notif.delivery_type)
              this.notifBits[notif.delivery_type][message.status] = bits
            }
          }
        }
      },
      getBits (message, type) {
        switch (type) {
          case 'EAT_LOCATION':
            let bits = message.split('{persons_number}')
            if (bits.length < 2) {
              bits.push(' ')
              bits.push(' ')
              return bits
            } else {
              let bits2 = bits[1].split('{date_time}')
              if (bits2.length < 2) {
                bits2.push(' ')
              }
              bits[1] = bits2[0]
              bits[2] = bits2[1]
            }
            return bits
          default:
            let bitsDef = message.split('{time}')
            if (bitsDef.length < 2) {
              bitsDef.push(' ')
            }
            return bitsDef
        }
        // this.parameters
      },
      getMsgFromBits (type, status) {
        var bits = this.notifBits[type][status]
        switch (type) {
          case 'EAT_LOCATION':
            return bits[0] + '{persons_number}' + bits[1] + '{date_time}' + bits[2]
          default:
            return bits[0] + '{time}' + bits[1]
        }
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')

        // get special messages
        for (var idx in this.model) {
          let notif = this.model[idx]
          for (var notifIdx in notif.messages) {
            let message = notif.messages[notifIdx]
            if (message.status === 'PROCESSING' || (message.status === 'DELIVERED' && notif.delivery_type === 'EAT_LOCATION')) {
              this.model[idx].messages[notifIdx].message = this.getMsgFromBits(notif.delivery_type, message.status)
            }
          }
        }

        var data = {
          'token': this.$session.get('token'),
          'push_notifications': JSON.stringify(this.model)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            swal({'text': self.$t('settingsPushNotif.notifUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch({})
          } else {
            swal({'text': self.$t('validationa.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch({})
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/PushNotifications.vue